import { render, staticRenderFns } from "./FlexibleSpaceB.vue?vue&type=template&id=0bafe730&scoped=true"
import script from "./FlexibleSpaceB.vue?vue&type=script&lang=js"
export * from "./FlexibleSpaceB.vue?vue&type=script&lang=js"
import style0 from "./FlexibleSpaceB.vue?vue&type=style&index=0&id=0bafe730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bafe730",
  null
  
)

export default component.exports